import React, { Suspense, lazy } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./ThankYouAttendees.css";


const SignUpForm = lazy(() => import("../SignUpForm/SignUpForm"));

const SponsorThankYouSection = ({ webpageData }) => {
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  const sponsors = webpageData?.sponsorSection?.sponsors || [];

  return (
    <div className="sponsor-thankyou-section">
      <Container>
        


      <div className="sponsor-thankyou-content">
          <div className="sponsor-thankyou-title">Thank You for Attending the Event</div>
          <p className="sponsor-thankyou-message">
          Thank you for your engagement, your passion, and your dedication to being a part of this historic moment. Your presence and contributions turned this event into more than just a conference—it became a launchpad for the future of Ai, blockchain, and business innovation in the U.S.
          </p>

          <p className="sponsor-thankyou-message custom-thankyou-changes">
          Let’s keep the conversation going—this is just the beginning. We’re already looking forward to the next opportunity to unite, innovate, and drive the future of Ai and crypto forward.
          </p>
          {/* <hr className="sponsor-thankyou-hr"></hr>
          <p className="sponsor-thankyou-message">
          To all attendees, thank you for showing up with curiosity and conviction. Your energy made this event more than a summit — it became a launchpad for change.<br/>We’ll keep the conversation going.<br/>Post your memories on social media and tag AngelAi. We will share it on this site.
          </p> */}
          
        </div>

        <div className="sponsor-thankyou-newchanges">
        <Suspense fallback={<div />}>
        <SignUpForm />
        </Suspense> 
        </div>
        

      </Container>
    </div>
  );
};

export default SponsorThankYouSection;
